<template>
  <section class="topVert has-text-default">
    <div class="blocSelection">
      <div class="level is-marginless" v-if="getNbrSelect">
        <div class="level-left is-marginless">
          <label class="leftViolet topViolet bottomViolet">
            Total de ma sélection
          </label>
        </div>
        <div class="level-right is-marginless">
          <p>
            <strong class="has-text-link p_size14 has-text-right">{{solde}}</strong>
            <label class="rightViolet">HT</label>
          </p>
        </div>
      </div>
      <div class="level is-marginless" v-else>
        <div class="level-item is-marginless">
          <label class="leftViolet topViolet bottomViolet">
            Aucun produit sélectionné
          </label>
        </div>
      </div>
      <div @click="isModalActive = true" class="pointer border">
        <p class="p_size14 has-text-centered topViolet bottomViolet">
          Demander des modifications
        </p>
      </div>
      <div @click="isRefuseModalActive = true" class="pointer">
        <p class="p_size14 has-text-centered topViolet bottomViolet">
          Refuser la proposition
        </p>
      </div>
      <div class="pointer validite">
        <div class="level">
          <div class="level-item">
            <div class="media">
              <b-icon
                icon="check-circle"
                size=""
                class="topViolet bottomViolet">
              </b-icon>
              <div @click="validMail" class="leftViolet media-content is-size-7">
                <p class="p_size14 has-text-weight-bold topViolet bottomViolet">
                  Valider la proposition
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="date" class="topViolet p_size12">Opportunité valide jusqu'au {{date}}</p>
    <b-modal v-model="isModalActive" :width="640">
      <div class="card modalSpace">
        <label>Sujet du message
          <label class="errorBorder">(Obligatoire)</label>
        </label>
        <b-field
          :type="typeSujet"
          :message="errorSujet"
        >
          <b-input v-model="sujet"></b-input>
        </b-field>
        <label class="topVert">Vos modifications
          <label class="errorBorder">(Obligatoire)</label>
        </label>
        <b-field
          :type="typeMess"
          :message="errorMess"
        >
          <b-input v-model="message" type="textarea"></b-input>
        </b-field>
        <div class="columns is-marginless">
          <div @click="isModalActive = false" class="column is-offset-7 is-grey is-paddingless">
            <a class="button buttonBorder buttonPadding is-rounded p_size14 has-text-default">
              Annuler</a>
          </div>
          <div @click="envoyer() ; proposValide = true ; message = ''"
               class="column is-paddingless"
          >
            <a class="button buttonPadding is-primary is-rounded p_size14">
              <p>Envoyer</p>
              <b-icon
                icon="send"
                size="small"
                class="">
              </b-icon>
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isValidModalActive" :width="640">
      <div class="card modalSpace">
        <div v-if="proposValide==true">
          <div class="columns is-mobile is-marginless">
            <div class="media centre">
              <img src="@/assets/img/icon_demande_d_envoi.png" alt="">
            </div>
          </div>
          <div class="columns is-marginless">
            <h2 class="media centre has-text-weight-bold">Demande envoyée</h2>
          </div>
          <div class="columns is-marginless">
            <div class="media centre">
              <p class="p_size14">La proposition a bien été envoyée à <br>
              <strong class="leftViolet has-text-primary">{{email}}</strong>
            </p>
            </div>
          </div>
        </div>
        <div v-if="proposValide==false">
          <div class="columns is-mobile is-marginless">
            <div class="media centre">
              <img src="@/assets/img/icon_refu.png" alt="">
            </div>
          </div>
          <div class="columns is-marginless">
            <h2 class="media centre has-text-weight-bold">Proposition refusée</h2>
          </div>
          <div class="columns is-marginless">
            <p class="p_size14 media centre">Nous avons informé le commercial de votre décision.</p>
          </div>
        </div>
        <div class="columns topViolet">
          <div @click="isValidModalActive = false" class="media centre is-grey is-paddingless">
            <a class="button buttonPadding is-primary is-rounded p_size14">
              Fermer</a>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isRefuseModalActive" :width="640">
      <div class="card modalSpace">
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <img src="@/assets/img/icon_refu.png" alt="">
          </div>
        </div>
        <div class="columns is-marginless">
          <div class="media centre">
            <h2 class="has-text-weight-bold bottomViolet">Refuser la proposition</h2>
          </div>
        </div>
          <div class="columns is-marginless">
            <p class="p_size14 media centre bottomViolet">
              Êtes-vous sûr de vouloir refuser la proposition?
            </p>
          </div>
        <div class="columns is-marginless">
          <div class="media centre topViolet">
            <div class="rightViolet" @click="isRefuseModalActive = false">
              <a class="button buttonBorder buttonPadding is-rounded p_size10 has-text-default">
                Retour</a>
            </div>
            <div
            @click="refusMail()">
              <a class="button buttonPadding is-rounded is-primary p_size10">
                Refuser la proposition</a>
            </div>
          </div>
        </div>
        <div class="columns is-marginless">
          <div class="media centre topVert">
            <div @click="isModalActive = true ; isRefuseModalActive = false">
              <a class="button buttonPadding buttonBorder is-rounded p_size10 has-text-default">
                Demander des modifications</a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isOkModalActive" :width="640">
      <div class="card modalSpace">
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <img src="@/assets/img/icon_valid_opp.png" alt="">
          </div>
        </div>
        <div class="columns is-marginless">
          <div class="media centre">
            <h2 class="has-text-weight-bold">Proposition validée</h2>
          </div>
        </div>
          <div class="columns is-marginless">
            <p class="p_size14 media centre">
              Le commercial a été prévenu de votre validation et reviendra vers vous rapidement</p>
          </div>
          <div class="columns is-marginless">
            <div class="media centre topVert">
              <div @click="isOkModalActive = false">
              <a class="button buttonPadding is-rounded p_size10 is-primary">Fermer</a>
              </div>
            </div>
          </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatNum } from '@/services/opportunite/formatTab';
import { sendModifidationEmail, sendValidationEmail, sendRefusEmail } from '@/services/mail/sendEmail';

export default {
  name: 'blocSelection',
  props: ['date', 'commercial', 'client', 'themeCampagne', 'email'],
  data() {
    return {
      isModalActive: false,
      isValidModalActive: false,
      isRefuseModalActive: false,
      isOkModalActive: false,
      sujet: 'Je souhaite une modification sur la proposition',
      message: '',
      errorMess: '',
      typeMess: '',
      errorSujet: '',
      typeSujet: '',
      proposValide: true,
    };
  },
  computed: {
    ...mapGetters([
      'getSolde',
      'getNbrSelect',
    ]),
    solde() {
      return formatNum(this.getSolde);
    },
  },
  methods: {
    verifSujet() {
      if (this.sujet) {
        this.errorSujet = '';
        this.typeSujet = '';
        return true;
      }
      this.typeSujet = 'errorBorder';
      this.errorSujet = 'Veuillez renseigner ce champ';
      return false;
    },
    validMail() {
      this.isOkModalActive = true;
      sendValidationEmail(this.$route.params.id,
        this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
    },
    refusMail() {
      this.isValidModalActive = true;
      this.isRefuseModalActive = false;
      this.proposValide = false;
      sendRefusEmail(this.$route.params.id,
        this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
    },
    verifMess() {
      if (this.message) {
        this.errorMess = '';
        this.typeMess = '';
        return true;
      }
      this.typeMess = 'errorBorder';
      this.errorMess = 'Veuillez renseigner ce champ';
      return false;
    },
    envoyer() {
      if (this.verifSujet() && this.verifMess()) {
        this.isValidModalActive = true;
        this.isModalActive = false;
        sendModifidationEmail(
          this.sujet, this.message, this.$route.params.id,
          this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/composants/blocSelection.vue